import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { boardSetCardProperties } from '../../../../../../../../../rest/effects/board/boardSetCardProperties';
import { SegmentBoardEvent, segmentTrackAction } from '../../../../../../../../../middlewares/segment';
import {
    SegmentBoardCardPropertiesType,
    SegmentBoardOption,
    SegmentBoardOptionSourceValue,
    SegmentBoardOptionStatusValue
} from '../../../../../../../../../middlewares/segment/trackEntities/boardEvents';
import { EAsidePanelProperty } from '../../../../../../asidePanel/components/AsidePanel/types';
import { ICardProperty } from '../../../../../../../../../types/rest/IRestBoardMeta';
import { toggleCardDefaultCustomPropertyOptions } from './toggleCardDefaultCustomPropertyOptions';
import { getBoardCardProperties } from '../../../../../../../../../store/model/board/selectors/getBoardCardProperties';

export const toggleCardDefaultProperty = (
    boardId: TBoardId,
    property: EAsidePanelProperty,
    option?: string
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const cardProperties = getBoardCardProperties(getState(), boardId);
        const index = cardProperties.findIndex(item => item.property === property);
        let eventStatus = SegmentBoardOptionStatusValue.OFF;
        const cardProperty: ICardProperty = { property };
        if (property === EAsidePanelProperty.CARD_CUSTOM) {
            cardProperty.options = toggleCardDefaultCustomPropertyOptions(getState(), boardId, option);
        }
        if (index < 0) {
            cardProperty.isDefault = true;
            eventStatus = SegmentBoardOptionStatusValue.ON;
        }
        dispatch(boardSetCardProperties(boardId, cardProperty));
        dispatch(segmentTrackAction(SegmentBoardEvent.CARD_DEFAULT_PROPERTY_CLICKED, {
            name: SegmentBoardOption.SOURCE,
            value: SegmentBoardOptionSourceValue.BOARD,
        }, [{
            name: SegmentBoardOption.TARGET,
            value: property.toLocaleLowerCase()
        }, {
            name: SegmentBoardOption.STATUS,
            value: eventStatus
        }, {
            name: SegmentBoardOption.TYPE,
            value: SegmentBoardCardPropertiesType.DEFAULT
        }]));
    };
    return action;
};
